import { ApiGetRequest } from './api-get-request';
import { ApiParameters } from './api-parameters';

export class SVKRequest extends ApiGetRequest
{
    public constructor(ticketNumber: number, ticketLetter: string, webapiBasepath: string)
    {
        const parameters = new ApiParameters()
            .addQueryParameter('ticketnumber', ticketNumber)
            .addQueryParameter('ticketletter', ticketLetter);

        super('visitorkey', parameters, null, webapiBasepath);
    }
}



